import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';
import { Shadows } from '@picsart/design-system/foundation/shadows';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';

// Roomy enough for a full preset title plus its category, without letting the
// field swallow the header. The compact width takes over below `lg`, where the
// header has the credits ring, avatar, and close button to fit as well.
const FIELD_WIDTH = 420;
const FIELD_WIDTH_COMPACT = 320;
const POPOVER_MAX_HEIGHT = 480;

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      width: FIELD_WIDTH,
      maxWidth: '100%',
      [`@media (max-width: ${Breakpoints.lg - 1}px)`]: {
        width: FIELD_WIDTH_COMPACT,
      },
    },
    // Layout only. The DS owns the field's border, radius, and background —
    // it renders them on the inner input, so any radius/overflow here clips
    // that border instead of shaping it.
    field: {
      width: '100%',
    },
    popover: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      marginTop: Spacings.s8,
      maxHeight: POPOVER_MAX_HEIGHT,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      // Same radius the DS gives `TextField`, so field and popover read as one
      // control rather than two shapes.
      borderRadius: CornerRadius.r8,
      backgroundColor: BackgroundColors.popover,
      boxShadow: Shadows.tint2,
      zIndex: StackingContext.popover,
    },
  },
  { name: 'search-dropdown' }
);

export default useStyles;
